export const MOVIE_POSTER_URL = 'https://image.tmdb.org/t/p/w500'; //url used by API (the movie database) to show the movies cover/poster
export const API_BASE_URL = 'https://api.themoviedb.org/3';        //API base url
export const API_KEY = '4c9b18dcf47080054604596b7e94ce80';         //API authentication key
export const LANGUAGE = 'pt-PT';                                   //change the language of movie (title and details) to portuguese


